import React from "react";

// Local imports
import useMyTechStuff from "../../images/web_development/UseMyTechStuff.png";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function WD_Project_2() {
  // Use My Tech Stuff
  const openPopupBoxUseMyTechStuff = () => {
    const content = (
      <>
        <div className="image-center">
          <img
            className="portfolio-image-popupbox"
            src={useMyTechStuff}
            alt=""
          />
        </div>
        <p>
          An app designed for tech owners being able to rent out technology
          locally for profit
        </p>
        <a
          className="hyper-link"
          onClick={() =>
            window.open(
              "https://github.com/ttwebft20-Use-My-Tech-Stuff/",
              "_blank"
            )
          }
        >
          GitHub Repo
        </a>
        &nbsp;
        <a
          className="hyper-link"
          onClick={() =>
            window.open(
              "https://friendly-hamilton-b1c31c.netlify.app/",
              "_blank"
            )
          }
        >
          Deployment
        </a>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Use My Tech Stuff Application",
        },
      },
    });
  };

  const popupboxConfigUseMyTechStuff = {
    titleBar: {
      enable: true,
      text: "Use My Tech Stuff Application",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div className="portfolio-image-box" onClick={openPopupBoxUseMyTechStuff}>
        <img
          className="portfolio-image"
          src={useMyTechStuff}
          alt="Screenshot of Use My Tech Stuff Application"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigUseMyTechStuff} />
    </>
  );
}

export default WD_Project_2;
